import { useImpersonationContext } from '@/contexts/ImpersonationContext';

export function useImpersonation() {
  return useImpersonationContext();
}
